import React, { createContext, useState } from "react";
import { getSessionStorageItem } from "../utils/sessionStorageUtils";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [user, setUser] = useState(
    getSessionStorageItem("haqt_userinfo") || {},
  );
  const [showSpinner, setShowSpinner] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [tenantData, setTenantData] = useState({
    isInitialLoad: true,
    data: {},
  }); 
  const [showTenantToggle, setShowTenantToggle] = useState(true);
  const isAdminUser = (user.role === "admin");
  return (
    <AppContext.Provider value={{ 
      user, setUser, 
      showSpinner, setShowSpinner,
      breadcrumbs, setBreadcrumbs,
      tenantData,setTenantData,
      showTenantToggle, setShowTenantToggle,
      isAdminUser
    }}>
      {children}
    </AppContext.Provider>
  );
};
